import { render, staticRenderFns } from "./chooseUnit.vue?vue&type=template&id=f4789e08&scoped=true&"
import script from "./chooseUnit.vue?vue&type=script&lang=js&"
export * from "./chooseUnit.vue?vue&type=script&lang=js&"
import style0 from "./chooseUnit.vue?vue&type=style&index=0&id=f4789e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4789e08",
  null
  
)

export default component.exports